<townip-modal heading="New Client {{serviceType}}" (onHide)="hide()">
  <townip-modal-body>
    <form>
      <div class="select-area">
        <div class="row">
          <div class="col-12">
            <label>Enter a client company</label>
            <townip-dropdown
              class="standard-control"
              name="selectedCompany"
              placeholder="Please Select"
              [(ngModel)]="selectedCompanyLite"
              (ngModelChange)="selectCompany()"
              [fluid]="true"
              required>
              <townip-option
                *ngFor="let company of companies"
                [label]="company.companyName"
                [value]="company">
              </townip-option>
            </townip-dropdown>
          </div>
        </div>
        <div class="row margin-top-30">
          <div class="col-12">
            <label>Select a company user</label>
            <townip-dropdown
              class="standard-control"
              name="selectedCompanyUser"
              placeholder="Please Select"
              [(ngModel)]="selectedCompanyUser"
              (ngModelChange)="selectCompanyUser()"
              [fluid]="true"
              required>
              <townip-option
                *ngFor="let companyUser of companyUsers"
                [label]="companyUser.label"
                [value]="companyUser.value">
              </townip-option>
            </townip-dropdown>
          </div>
        </div>
      </div>

      <div class="border rounded mb-4" style="margin: 0 20px" *ngIf="preIntakeInstruction?.instructionText">
        <div class="p-4">
          <p class="font-weight-bold mb-3">Client Care Instruction</p>
          <div class="ql-editor p-0" [innerHTML]="preIntakeInstruction.instructionText"></div>
        </div>
        <div class="d-flex px-4 py-3 bg-light align-items-baseline">
          <i class="fa fa-clock-o mr-2"></i>
          <div>
            Last Updated by
            <strong>{{preIntakeInstruction?.lastModifiedBy | generateFullname}}</strong>
            on <strong>{{preIntakeInstruction?.lastModified | standardDateTime}}</strong>
          </div>
        </div>
      </div>


    </form>
  </townip-modal-body>
  <townip-modal-footer>
    <button class="btn btn-secondary text-white" (click)="this.modal.hide()">Cancel
    </button>
    <button class="btn btn-primary" (click)="submit()">Confirm</button>
  </townip-modal-footer>
</townip-modal>
